import { NavLink, useLocation } from "react-router-dom";
import { House, ClockCounterClockwise, Users, GearSix, Receipt, CalendarBlank } from "@phosphor-icons/react";

const items = [
  { to: "/", label: "Home", icon: House, testid: "nav-home" },
  { to: "/schedule", label: "Schedule", icon: CalendarBlank, testid: "nav-schedule" },
  { to: "/history", label: "History", icon: ClockCounterClockwise, testid: "nav-history" },
  { to: "/receipts", label: "Receipts", icon: Receipt, testid: "nav-receipts" },
  { to: "/clients", label: "Clients", icon: Users, testid: "nav-clients" },
  { to: "/settings", label: "Settings", icon: GearSix, testid: "nav-settings" },
];

export const BottomNav = () => {
  const loc = useLocation();
  if (loc.pathname.startsWith("/share/") || loc.pathname.startsWith("/e/") || loc.pathname.startsWith("/payment")) return null;
  return (
    <nav className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-md bg-white border-t border-zinc-200 z-40">
      <div className="grid grid-cols-6">
        {items.map((it) => {
          const Icon = it.icon;
          return (
            <NavLink
              key={it.to}
              to={it.to}
              end={it.to === "/"}
              data-testid={it.testid}
              className={({ isActive }) =>
                `flex flex-col items-center gap-0.5 py-2.5 text-[10px] font-semibold uppercase tracking-wide transition-colors ${
                  isActive ? "text-orange-600" : "text-zinc-400"
                }`
              }
            >
              {({ isActive }) => (
                <>
                  <Icon size={22} weight={isActive ? "fill" : "regular"} />
                  {it.label}
                </>
              )}
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
};
